<template>
  <div class="w-100%">

    <!-- 选择日期 -->
      <div class="block" style="margin-top:0px;color:#000;">
        <span class="demonstration">时间</span>
        <el-date-picker
          v-model="keywordss"
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <el-button slot="append" size="small" icon="el-icon-search" :loading="isLoading" @click="init()"></el-button>
      </div>
    <!-- 选择日期end -->
    <div style="width:100%;height:800px;position:relative;margin-top:0px;overflow: hidden;">
        <div id="kind" style= "position:absolute;top:0px;left:50px;width: 800px; height: 450px;margin:0px;color:#111;  "></div>
        <div id="kind2" style= "position:absolute;top:360px;left:520px;width: 800px; height: 450px;margin:0px;color:#111;  "></div>
    </div>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import china from '../../../../assets/js/china'
  import echarts from 'echarts'

  export default {
    data() {
      return {
        loading: false,
        isLoading: false,
        keywordss: '',
        dialogFormVisible:false,
      }
    },
    mounted () {
      _g.openGlobalLoading()
      this.isLoading = true
      this.init()
    },
    methods: {
      reviewAllUsers() {
        const data = {
          params: {
            keywords: this.keywordss,
            id: this.$route.params.id
          }
        }
        this.loading = true
        this.apiGet('admin/company/statistics', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.isLoading = false
            this.drawLine1(data.list1, data.count1)
            this.drawLine2(data.list2, data.count2)
          }, () => {
            this.isLoading = false
          })
        })
      },
      drawLine1 (datalist, count = "0") {
        var m2R2Data = datalist
        m2R2Data.forEach(function(item,index) {
            if(index==0){
                item.itemStyle.color = "#2ec7c9";
            }
            if(index==1){
                item.itemStyle.color = "#b6a2de";
            }
            if(index==2){
                item.itemStyle.color = "#5ab1ef";
            }
            if(index==3){
                item.itemStyle.color = "#ffb980";
            }
            if(index==4){
                item.itemStyle.color = "#d87a80";
            }
            if(index==5){
                item.itemStyle.color = "#8d98b3";
            }
            if(index==6){
                item.itemStyle.color = "#e5cf0d";
            }
            if(index==7){
                item.itemStyle.color = "#97b552";
            }
            if(index==8){
                item.itemStyle.color = "#95706d";
            }
            if(index==9){
                item.itemStyle.color = "#dc69aa";
            }
            if(index==10){
                item.itemStyle.color = "#07a2a4";
            }
            if(index==11){
                item.itemStyle.color = "#9a7fd1";
            }
            if(index==12){
                item.itemStyle.color = "#588dd5";
            }
            if(index==13){
                item.itemStyle.color = "#f5994e";
            }
            if(index==14){
                item.itemStyle.color = "#c05050";
            }
            if(index==15){
                item.itemStyle.color = "#59678c";
            }
            if(index==16){
                item.itemStyle.color = "#c9ab00";
            }
            if(index==17){
                item.itemStyle.color = "#7eb00a";
            }
            if(index==18){
                item.itemStyle.color = "#6f5553";
            }
            if(index==19){
                item.itemStyle.color = "#c14089";
            }
        });
        let myChart = echarts.init(document.getElementById('kind'))
        // 绘制图表
        myChart.setOption({
            title: [
            {
                text: '报销类型',
                textStyle: {
                    fontSize: 18,
                    color: "#008acd"
                },
                left: 360
            },    
            {
                text: '合计',
                subtext: count?count:"0",
                textStyle:{
                    fontSize:15,
                    color:"#2ec7c9"
                },
                subtextStyle: {
                    fontSize: 16,
                    color: '#2ec7c9'
                },
                textAlign:"center",
                x: '34%',
                y: '45%',
            }],
            tooltip: {
                trigger: 'item',
                formatter:function (parms){
                var str=  parms.seriesName+"</br>"+
                    parms.marker+""+parms.data.legendname+"</br>"+
                    "数量："+ parms.data.value+"</br>"+
                    "占比："+ parms.percent+"%";
                    return  str ;
                }
            },
            legend: {
                type:"scroll",
                orient: 'vertical',
                right:'20%',
                align:'left',
                top:'middle',
                textStyle: {
                    color:'#8C8C8C'
                },
                width:144,
                height:144,
            },
            series: [
                {
                    name:'类型',
                    type:'pie',
                    center: ['35%', '50%'],
                    radius: ['40%', '65%'],
                    clockwise: false, //饼图的扇区是否是顺时针排布
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: true,
                            position: 'outter',
                            formatter:function (parms){
                                return parms.data.legendname
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                        length:5,
                        length2:3,
                        smooth:true,
                        }
                    },
                    data:m2R2Data
                }
            ]
        })
      },
      drawLine2 (datalist, count = "0") {
        var m2R2Data = datalist
        m2R2Data.forEach(function(item,index) {
            if(index==0){
                item.itemStyle.color = "#27727b";
            }
            if(index==1){
                item.itemStyle.color = "#fcce10";
            }
            if(index==2){
                item.itemStyle.color = "#e87c25";
            }
            if(index==3){
                item.itemStyle.color = "#b5c334";
            }
            if(index==4){
                item.itemStyle.color = "#fe8463";
            }
            if(index==5){
                item.itemStyle.color = "#9bca63";
            }
            if(index==6){
                item.itemStyle.color = "#fad860";
            }
            if(index==7){
                item.itemStyle.color = "#f3a43b";
            }
            if(index==8){
                item.itemStyle.color = "#60c0dd";
            }
            if(index==9){
                item.itemStyle.color = "#d7504b";
            }
            if(index==10){
                item.itemStyle.color = "#c6e579";
            }
            if(index==11){
                item.itemStyle.color = "#f4e001";
            }
            if(index==12){
                item.itemStyle.color = "#f0805a";
            }
            if(index==13){
                item.itemStyle.color = "#26c0c0";
            }
            if(index==14){
                item.itemStyle.color = "#e01f54";
            }
            if(index==15){
                item.itemStyle.color = "#a4d8c2";
            }
            if(index==16){
                item.itemStyle.color = "#d3758f";
            }
            if(index==17){
                item.itemStyle.color = "#a092f1";
            }
            if(index==18){
                item.itemStyle.color = "#dcc392";
            }
            if(index==19){
                item.itemStyle.color = "#ff6666";
            }
        });
        let myChart = echarts.init(document.getElementById('kind2'))
        // 绘制图表
        myChart.setOption({
            title: [
            {
                text: '发票类型',
                textStyle: {
                    fontSize: 18,
                    color: "#27727b"
                },
                left: 360
            },    
            {
                text: '合计',
                subtext: count?count:"0",
                textStyle:{
                    fontSize:15,
                    color:"#c1232b"
                },
                subtextStyle: {
                    fontSize: 16,
                    color: '#c1232b'
                },
                textAlign:"center",
                x: '34%',
                y: '45%',
            }],
            tooltip: {
                trigger: 'item',
                formatter:function (parms){
                var str=  parms.seriesName+"</br>"+
                    parms.marker+""+parms.data.legendname+"</br>"+
                    "数量："+ parms.data.value+"</br>"+
                    "占比："+ parms.percent+"%";
                    return  str ;
                }
            },
            legend: {
                type:"scroll",
                orient: 'vertical',
                right:'20%',
                align:'left',
                top:'middle',
                textStyle: {
                    color:'#8C8C8C'
                },
                width:144,
                height:144,
            },
            series: [
                {
                    name:'类型',
                    type:'pie',
                    center: ['35%', '50%'],
                    radius: ['40%', '65%'],
                    clockwise: false, //饼图的扇区是否是顺时针排布
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: true,
                            position: 'outter',
                            formatter:function (parms){
                                return parms.data.legendname
                            }
                        }
                    },
                    labelLine: {
                        normal: {
                        length:5,
                        length2:3,
                        smooth:true,
                        }
                    },
                    data:m2R2Data
                }
            ]
        })
      },
      init() {
        this.reviewAllUsers()
      }
    },
    created() {
      this.init()
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// index.vue?49259736